import {
  NOTIFICATION_DIALOG_MESSAGES,
  NotificationDialogMessages,
} from "./notification-dialog.messages";
import {
  NOTIFICATIONS_FILTER_MESSAGES,
  NotificationsFiltersMessages,
} from "./notification-filters.messages";
import {
  NOTIFICATION_REQUEST_MESSAGES,
  NotificationRequestMessages,
} from "./notification-request-messages";
import {
  NOTIFICATIONS_TABLE_MESSAGES,
  NotificationsTableMessages,
} from "./notifications-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type NotificationsMessages = NotificationsFiltersMessages &
  NotificationsTableMessages &
  SidebarMessages &
  NotificationRequestMessages &
  NotificationDialogMessages &
  ActionButtonMessages & {
    notificationsPageTitle: string;
    notificationsBreadCrumbTitle: string;
    markAllAsReadButton: string;
    details2Popover: string;
  };

export const NOTIFICATIONS_MESSAGES: NotificationsMessages = {
  notificationsPageTitle: "Notificações",
  notificationsBreadCrumbTitle: "Notificações",
  markAllAsReadButton: "Marcar todas como lidas",
  details2Popover: "Detalhes",

  ...NOTIFICATION_DIALOG_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...NOTIFICATION_REQUEST_MESSAGES,
  ...NOTIFICATIONS_FILTER_MESSAGES,
  ...NOTIFICATIONS_TABLE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default NOTIFICATIONS_MESSAGES;
